import { render, staticRenderFns } from "./EmissionPieCharts.vue?vue&type=template&id=1676878a&scoped=true"
import script from "./EmissionPieCharts.vue?vue&type=script&lang=js"
export * from "./EmissionPieCharts.vue?vue&type=script&lang=js"
import style0 from "./EmissionPieCharts.vue?vue&type=style&index=0&id=1676878a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1676878a",
  null
  
)

export default component.exports